<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-row>
          <b-col
            class="mb-xl-0 mb-3 d-flex justify-content-center align-items-center video-wrapper"
            cols="12"
          >
            <b-skeleton
              width="100%"
              height="400px"
              v-if="loadingVideo"
            ></b-skeleton>
            <div class="w-100" v-if="!loadingVideo && !session.access">
              <b-alert variant="danger" show>
                <div class="alert-body">
                  <p>
                    <span v-if="session.has_penalty"
                      >دسترسی شما به دلیل وجود جریمه پرداخت نشده مسدود شده است.
                      برای مشاهده جریمه های خود به صفحه ی
                      <b-link :to="{ name: 'profile-penalties' }"
                        >جریمه ها</b-link
                      >
                      مراجعه کنید.
                    </span>
                    <span v-else
                      >شما به این جلسه دسترسی ندارید برای مشاهده این درس جلسات
                      قبلی را مشاهده کرده و تمرین های آن را پاسخ دهید.</span
                    >
                  </p>
                </div>
              </b-alert>
            </div>
            <div
              class="w-100"
              v-if="
                !loadingVideo &&
                session.access &&
                (Object.keys(session.video).length == 0
                  ? true
                  : !session.video.type)
              "
            >
              <b-alert variant="info" show>
                <div class="alert-body">
                  <p>
                    <span>ویدیویی تاکنون بارگذاری نشده است.</span>
                  </p>
                </div>
              </b-alert>
            </div>
            <div
              class="col-12 px-md-3 pb-md-2 video_here"
              v-show="
                !loadingVideo &&
                session.access &&
                session.video &&
                session.video.type
              "
            >
              <b-alert
                variant="danger"
                class="mb-1"
                show
                v-if="
                  session.video &&
                  session.video.type &&
                  session.video.type == 'youtube'
                "
              >
                <div class="alert-body">
                  <p>لطفا برای مشاهده ویدیو فیلتر شکن خود را روشن کنید!</p>
                </div>
              </b-alert>
              <b-button
                block
                variant="primary"
                v-if="
                  session.video &&
                  session.video.type &&
                  session.video.type == 'bbb'
                "
                :href="session.video.join_url"
                class="my-2"
                target="_blank"
              >
                <span class="mx-1">
                  <feather-icon :icon="'EyeIcon'" />
                </span>
                برای
                {{
                  userData.permissions.permissions.length ? "شروع" : "ورود به"
                }}
                کلاس کلیک کنید.</b-button
              >
              <b-embed
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                v-if="
                  session.video &&
                  session.video.type &&
                  session.video.type !== 'kavimo' &&
                  session.video.type !== 'bbb'
                "
                type="iframe"
                aspect="16by9"
                class="w-100 h-100"
                :src="changeUrl(session.video.source)"
                allowfullscreen
              ></b-embed>
            </div>
          </b-col>
          <div
            class="d-flex w-100 justify-content-end mr-3"
            v-if="
              !loading &&
              (session.pamphlet ||
                session.pamphlet_file ||
                session.has_exercises)
            "
          >
            <b-badge
              variant="info"
              class="py-50 px-1 mx-50"
              v-if="session.has_exercises"
              >تمرین</b-badge
            >
            <b-badge
              variant="warning"
              class="py-50 px-1 mr-1"
              v-if="session.pamphlet || session.pamphlet_file"
              >جزوه</b-badge
            >
          </div>
          <b-col cols="12">
            <div v-if="loading" class="w-100 d-flex justify-content-between">
              <b-skeleton width="80px" height="30px"></b-skeleton>
              <b-skeleton width="80px" height="30px"></b-skeleton>
            </div>
            <div
              v-else
              class="w-100 d-flex flex-wrap justify-content-between align-items-center"
            >
              <h2 class="font-weight-bold">{{ session.name }}</h2>
              <b-button-group
                class="my-1"
                v-if="$route.path.includes('course')"
              >
                <b-button
                  v-if="nextSession"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  :href="nextSession"
                >
                  <span>بعدی</span>
                  <feather-icon icon="ArrowRightIcon" class="ml-50" />
                </b-button>

                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="danger"
                  v-if="
                    Object.keys(userData).length &&
                    session.access &&
                    !session.is_seen
                  "
                  :disabled="!session.access"
                  @click="finishedSession"
                >
                  <span>اتمام جلسه</span>
                  <feather-icon icon="" />
                </b-button>
                <b-button
                  v-if="prevSession"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="warning"
                  :href="prevSession"
                >
                  <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                  <span>قبلی</span>
                </b-button>
              </b-button-group>
            </div>

            <b-media no-body>
              <b-media-body
                class="d-flex flex-wrap justify-content-between w-100 my-1"
              >
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mr-2 mb-1"
                ></b-skeleton>
                <div class="d-flex mr-2 mb-1" v-else-if="session.available_at">
                  <span
                    ><feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع :
                  </span>

                  <span>{{ calcDate(session.available_at) }}</span>
                </div>
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mr-2 mb-1"
                ></b-skeleton>

                <div
                  class="d-flex mr-2 mb-1"
                  v-else-if="session.unavailable_at"
                >
                  <span
                    ><feather-icon size="14" icon="CalendarIcon" /> تاریخ پایان
                    :
                  </span>

                  <span>{{ calcDate(session.unavailable_at) }}</span>
                </div>
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mb-1"
                ></b-skeleton>

                <div class="d-sm-flex d-none mb-1" v-else>
                  <span> وضعیت : </span>

                  <b-badge
                    :variant="session.active ? 'success' : 'danger'"
                    class="rounded"
                  >
                    {{ session.active ? "فعال" : "غیر فعال" }}
                  </b-badge>
                </div>
                <template v-if="$route.path.includes('course')">
                  <div class="d-lg-none d-block w-100">
                    <div
                      v-show="
                        $route.path.includes('course') &&
                        !course.bought &&
                        course.can_buy &&
                        availableAtTimer
                      "
                    >
                      <div
                        class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap text-info my-25 font-weight-bold"
                      >
                        <div class="my-25">
                          زمان باقی مانده تا شروع ثبت نام :
                        </div>
                        <timer
                          class="flex-row"
                          color="info"
                          :time="course.available_at || ''"
                          v-model="availableAtTimer"
                        />
                      </div>
                    </div>
                    <div
                      v-show="
                        $route.path.includes('course') &&
                        !course.bought &&
                        course.can_buy &&
                        !availableAtTimer &&
                        unavailableAtTimer
                      "
                    >
                      <div
                        class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap my-25 font-weight-bold text-danger"
                      >
                        <div class="my-25">
                          زمان باقی مانده تا پایان مهلت ثبت نام :
                        </div>
                        <timer
                          class="flex-row"
                          color="danger"
                          :time="course.unavailable_at || ''"
                          v-model="unavailableAtTimer"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </b-media-body>
            </b-media>
            <b-skeleton width="100%" height="100px" v-if="loading"></b-skeleton>
            <div v-else-if="session.brief_description">
              <div>
                <span class="font-weight-bold h5">توضیحات</span>
                <div
                  v-html="session.brief_description"
                  class="text-justify py-1"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col>
      <div v-if="loading">
        <div class="d-flex justify-content-center w-100">
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
        </div>
        <b-skeleton width="100%" height="300px"></b-skeleton>
      </div>
      <session-tabs
        :session="session"
        :exercises="exercises"
        @getSession="getSessionExercise"
        @getCourse="$emit('getCourse')"
        v-else
      />
    </b-col>
    <b-col
      cols="12"
      class="d-flex d-md-none"
      v-if="$route.path.includes('course')"
    >
      <sidebar
        :loading="loadingCourse"
        :topics="topics"
        :course="course"
        class="w-100"
      />
    </b-col>
    <b-modal
      v-model="visible"
      hide-footer
      size="sm"
      centered
      v-if="session.has_penalty"
    >
      <b-alert variant="danger" show>
        <div class="alert-body">
          <p>
            <span
              >دسترسی شما به دلیل وجود جریمه پرداخت نشده مسدود شده است. برای
              مشاهده جریمه های خود به صفحه ی
              <b-link class="text-primary" :to="{ name: 'profile-penalties' }"
                >جریمه ها</b-link
              >
              مراجعه کنید.
            </span>
          </p>
        </div>
      </b-alert>
    </b-modal>
  </b-row>
</template>

<script>
import {
  BEmbed,
  BRow,
  BCol,
  BCard,
  BMedia,
  BBadge,
  BMediaBody,
  BSkeleton,
  BButtonGroup,
  BButton,
  BAlert,
  VBModal,
  BModal,
  BLink,
} from "bootstrap-vue";
import SessionTabs from "./session-tabs/SessionTabs.vue";
import Ripple from "vue-ripple-directive";
import NoSSR from "vue-no-ssr";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Timer from "@core/components/timer/Timer.vue";
import Sidebar from "../Sidebar.vue";
export default {
  components: {
    BEmbed,
    BRow,
    BCol,
    BCard,
    BBadge,
    BMedia,
    BMediaBody,
    BSkeleton,
    BButtonGroup,
    BButton,
    SessionTabs,
    NoSSR,
    Timer,
    BAlert,
    BModal,
    BLink,
    Sidebar,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  props: {
    loadingCourse: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => {},
    },
    topics: {
      type: Array,
      default: () => [],
    },
    sessions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      video: "",
      loading: false,
      loadingVideo: false,
      visible: false,
      session: {},
      exercises: [],
      nextSession: "",
      prevSession: "",
      availableAtTimer: true,
      unavailableAtTimer: true,
    };
  },
  computed: {
    finalAmount() {
      let finalAmount = 0;
      if (this.course.percentage) {
        finalAmount =
          Number(this.course.amount) -
          (Number(this.course.amount) * Number(this.course.rebate)) / 100;
      } else {
        finalAmount = Number(this.course.amount) - Number(this.course.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  methods: {
    changeUrl(url) {
      let link = url;
      let tempUrl = url.split("/");
      url.includes("youtu.be")
        ? (link =
            "https://www.youtube.com/embed/" + tempUrl[tempUrl.length - 1])
        : "";
      return link;
    },
    async getSessionExercise() {
      this.loading = true;
      await this.getSession();
      this.loading = false;
    },

    $eval(script) {
      return eval(script);
    },
    async finishedSession() {
      this.loading = true;
      try {
        await this.$http.post(
          `/panel/courses/${this.$route.params.id}/sessions/${this.$route.params.session_id}/seen`,
          {
            params: {
              _method: "patch",
            },
          }
        );
      } catch (err) {}
      await this.getSession();
      !this.session.has_exercises && (await this.$emit("getCourse"));

      this.loading = false;
      if (this.session.has_exercises) {
        this.$toast(
          {
            component: ToastificationContent,

            props: {
              title: "تمرین این درس برای شما فعال شد.",
              icon: "CoffeeIcon",
              variant: "success",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    handleButtons() {
      if (this.sessions.length) {
        let index = this.sessions.findIndex(
          (session) => session.id == this.$route.params.session_id
        );
        this.nextSession =
          index == this.sessions.length - 1
            ? ""
            : `/courses/${this.$route.params.id}/sessions/${
                this.sessions[index + 1].id
              }`;
        this.prevSession =
          index == 0
            ? ""
            : `/courses/${this.$route.params.id}/sessions/${
                this.sessions[index - 1].id
              }`;
      }
    },
    async getSession() {
      try {
        let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
        let includes = Object.keys(this.userData).length
          ? ["faqs", "exercises"]
          : ["faqs"];
        if (this.$route.path.includes("course")) {
          const { data } = await this.$http.get(
            `${baseUrl}courses/${this.$route.params.id}/sessions/${this.$route.params.session_id}`,
            {
              params: {
                includes: includes,
              },
            }
          );
          this.session = data.data;
          this.exercises = [...data.data.exercises.exercises];
        } else {
          const { data } = await this.$http.get(
            `${baseUrl}sessions/${this.$route.params.session_id}`,
            {
              params: {
                includes: ["faqs"],
              },
            }
          );
          this.session = data.data;
        }
      } catch (err) {}
    },
  },

  async created() {
    this.loading = true;

    if (this.$route.path.includes("course")) {
      await this.handleButtons();
    }
  },
  watch: {
    sessions(val) {
      if (val.length) {
        this.handleButtons();
      }
    },
    async session(val) {
      val.has_penalty && (this.visible = true);
      if (val.video && val.video.type === "kavimo") {
        document.querySelector(".video_here").innerHTML = "";
        let iframes = await document.querySelectorAll("iframe:not(#goftino_w)");
        if (iframes.length) {
          await iframes[0].parentElement.removeChild(iframes[0]);
        }
        var s = await document.createElement("script");
        s.async = true;
        s.defer = "defer";
        s.src = await val.video.url;
        document.querySelector(".video_here").innerHTML =
          '<div class="' + val.video.class + '"></div>';
        await document.querySelector(".video_here").prepend(s);
      }
      setTimeout(() => {
        this.loadingVideo = false;
      }, 4000);
    },
    $route: {
      async handler(val) {
        this.loading = true;
        this.loadingVideo = true;

        if (val.path.includes("course")) {
          await this.handleButtons();
        }
        await this.getSession();
        this.loading = false;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
